// extracted by mini-css-extract-plugin
export default {"modalContent":"NoSelectedStorageAlertModal_modalContent__T76eg","modalText":"NoSelectedStorageAlertModal_modalText__l78HP"};